import router from './setup';
import states from './states'; // eslint-disable-line no-unused-vars
import hooks  from './hooks';  // eslint-disable-line no-unused-vars

export default router;